import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ContactModel } from 'src/app/models/archive/contact.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private _httpClient: HttpClient) { }

  createContact(contactContractModel: ContactModel): Observable<ContactModel> {
    return this._httpClient.post<ContactModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.CreateContact}`,
      contactContractModel);
  }

  deleteContact(contactId: number): Observable<ContactModel> {
    return this._httpClient.delete<ContactModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.DeleteContact}/${contactId}`);
  }

  exportGeneralConsultation(entityId: number, typeContact: number, isContact: boolean, filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('entityId', entityId).set('typeContact', typeContact).set('isContact', isContact)
      .set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllContactsWithPagination(entityId: number, typeContact: number, isContact: boolean, page: number, limit: number, columnSort: string | null, ascendant: boolean,
    filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('entityId', entityId).set('typeContact', typeContact).set('isContact', isContact).set('page', page).set('limit', limit)
      .set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.GetAllContactsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getContactById(contactId: number): Observable<ContactModel> {
    return this._httpClient.get<ContactModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.GetContactById}/${contactId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.GetColumnsForGeneralConsultationAsync}`);
  }

  getClientContactsByClientId(clientId: number, isContact: boolean): Observable<Array<ContactModel>> {
    return this._httpClient.get<Array<ContactModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.GetClientContactsByClientId}/${clientId}/${isContact}`);
  }

  updateContact(contactContractModel: ContactModel): Observable<ContactModel> {
    return this._httpClient.put<ContactModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.contact.UpdateContact}`,
      contactContractModel);
  }
}
